import React from 'react';
import { ControlLabel, FormControl, FormGroup, Panel } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select-plus';

const bidTypeOption = (bidType) => (
  <span>
    <FontAwesome name="square" style={{ color: bidType.color || '#fafafa' }} /> {bidType.value}
  </span>
);

const jobStatusOption = (jobStatus) => (
  <span>
    <FontAwesome name="square" style={{ color: jobStatus.color || '#fafafa' }} /> {jobStatus.status}
  </span>
);

const jobTypeOption = (jobType) => (
  <span>
    <FontAwesome name="square" style={{ color: jobType.color || '#fafafa' }} /> {jobType.name}
  </span>
);

const salespersonOption = ({ calendarColor, firstName, lastName }) => (
  <span>
    <FontAwesome name="square" style={{ color: calendarColor || '#fafafa' }} /> {`${firstName || ''} ${lastName || ''}`}
  </span>
);

const SearchForm = ({ customers, dropdowns, form, onCustomerSearch, onFormUpdate }) => (
  <Panel defaultExpanded>
    <Panel.Toggle componentClass={Panel.Heading}>
      <Panel.Title toggle>
        <FontAwesome name="search" /> Search Jobs
      </Panel.Title>
    </Panel.Toggle>
    <Panel.Collapse>
      <Panel.Body>
        <FormGroup>
          <ControlLabel>Name/Number</ControlLabel>
          <FormControl onChange={(e) => onFormUpdate({ query: e.target.value })} value={form.query || ''} />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Customer</ControlLabel>
          <Select
            isLoading={customers.loading}
            labelKey="name"
            placeholder="All"
            options={customers.customers}
            onChange={(c) => onFormUpdate({ customerId: c ? c.id : null })}
            onInputChange={onCustomerSearch}
            value={form.customerId || ''}
            valueKey="id"
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Job Status</ControlLabel>
          <Select
            labelKey="status"
            multi
            optionRenderer={jobStatusOption}
            options={dropdowns.jobStatuses}
            placeholder="All"
            value={form.jobStatuses}
            valueKey="value"
            valueRenderer={jobStatusOption}
            onChange={(e) => onFormUpdate({ jobStatuses: e })}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Job Type</ControlLabel>
          <Select
            labelKey="name"
            multi
            optionRenderer={jobTypeOption}
            options={dropdowns.jobTypes}
            placeholder="All"
            value={form.jobTypes}
            valueKey="id"
            valueRenderer={jobTypeOption}
            onChange={(e) => onFormUpdate({ jobTypes: e })}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Bid Type</ControlLabel>
          <Select
            labelKey="value"
            multi
            optionRenderer={bidTypeOption}
            options={dropdowns.bidTypes}
            placeholder="All"
            value={form.bidTypes}
            valueKey="value"
            valueRenderer={bidTypeOption}
            onChange={(e) => onFormUpdate({ bidTypes: e })}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Office</ControlLabel>
          <Select
            labelKey="name"
            multi
            options={dropdowns.offices}
            placeholder="All"
            value={form.offices}
            valueKey="id"
            onChange={(e) => onFormUpdate({ offices: e })}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Salesperson</ControlLabel>
          <Select
            multi
            labelKey="labelKey"
            optionRenderer={salespersonOption}
            options={dropdowns.salespeople}
            placeholder="All"
            value={form.salespeople}
            valueKey="id"
            valueRenderer={salespersonOption}
            onChange={(e) => onFormUpdate({ salespeople: e })}
          />
        </FormGroup>
      </Panel.Body>
    </Panel.Collapse>
  </Panel>
);

export default SearchForm;
